import { atomWithStorage } from '@capsicum/common';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

export const v2SupportedDestinationsWarningModalHashes = atomWithStorage<Record<string, string>>(
	'v2SupportedDestinationsModalHashes',
	{}
);

export const useV2SupportedDestinationsWarningModalHashes = () => {
	const [hashes, setHashesAtom] = useAtom(v2SupportedDestinationsWarningModalHashes);
	const isHashDifferent = useCallback((token: string, hash: string) => hashes[token] !== hash, [hashes]);

	const setHash = useCallback(
		(token: string, hash: string) => setHashesAtom(value => ({ ...value, [token]: hash })),
		[setHashesAtom]
	);

	return { isHashDifferent, setHash };
};
